import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=7d6c7abc&scoped=true&v-if=storySelected%20%26%26%20pageSelected%20%26%26%20pageSelected.isNative"
import script from "./highlight.vue?vue&type=script&lang=js"
export * from "./highlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c7abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6c7abc')) {
      api.createRecord('7d6c7abc', component.options)
    } else {
      api.reload('7d6c7abc', component.options)
    }
    module.hot.accept("./highlight.vue?vue&type=template&id=7d6c7abc&scoped=true&v-if=storySelected%20%26%26%20pageSelected%20%26%26%20pageSelected.isNative", function () {
      api.rerender('7d6c7abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/buttons/highlight.vue"
export default component.exports